var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 97,
    viewBox: "0 0 90 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.5944,
    r: 39,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.503 68.819C52.1409 46.6559 77.8016 46.8515 85.144 48.8189C83.108 56.4174 69.5126 79.4946 50.503 68.819Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9671 66.8189L80.3808 51.5689M50.503 68.819C52.1409 46.6559 77.8016 46.8515 85.144 48.8189C83.108 56.4174 69.5126 79.4946 50.503 68.819Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1633 63.819L61.5425 54.9398",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9829 59.8814L67.9732 52.4537M72.6946 56.0064L74.0215 51.0546",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8771 79.2315C67.8771 88.9315 59.9771 95.8315 50.2771 95.8315C40.5771 95.8315 32.5771 88.9315 32.5771 79.2315C32.5771 61.3315 46.0771 65.6315 50.1771 65.6315C54.8771 65.6315 67.8771 61.4315 67.8771 79.2315Z",
    fill: "#4D4D4D",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4771 70.2316C47.2771 72.2316 53.6771 72.7316 56.1771 70.2316",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9772 72.2316C35.2772 76.5316 35.9772 82.0316 37.9772 85.8316",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0772 77.6315C39.6772 81.0315 40.4772 84.3315 42.7772 86.4315",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5771 88.7316C40.9771 89.1316 41.4771 89.5316 41.8771 89.9316",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.377 59.9315C51.077 63.5315 51.077 67.8315 50.677 71.9315",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5237 40.6544C45.7317 41.0144 47.4237 41.8424 48.5997 43.1384C49.7757 44.4104 50.3637 45.9944 50.3637 47.8904C50.3637 49.3544 49.9797 50.7104 49.2117 51.9584C48.4437 53.1824 47.2677 54.1664 45.6837 54.9104C44.1237 55.6544 42.2037 56.0264 39.9237 56.0264C38.1477 56.0264 36.3957 55.7984 34.6677 55.3424C32.9637 54.8624 31.5117 54.1904 30.3117 53.3264L32.5797 48.8624C33.5397 49.5824 34.6437 50.1464 35.8917 50.5544C37.1637 50.9384 38.4597 51.1304 39.7797 51.1304C41.2437 51.1304 42.3957 50.8544 43.2357 50.3024C44.0757 49.7264 44.4957 48.9224 44.4957 47.8904C44.4957 45.8264 42.9237 44.7944 39.7797 44.7944H37.1157V40.9424L42.2997 35.0744H31.5717V30.3944H49.2117V34.1744L43.5237 40.6544Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversity);
export default __webpack_public_path__ + "static/media/university.695f1a9dc117e00f31089647908d9319.svg";
export { ForwardRef as ReactComponent };